module.exports = __webpack_public_path__ + "img/right-inquiry-image.17fc6e86.svg";